<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Events'"></navbar>
			<!--导航-->
			<!--块1-->
			<div v-if="eventsInfo" class="block_1">
				<div class="block_1_box">
					<div class="top_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Meet with Us at<br />{{ eventsInfo.title }}</div>
						<div class="txt">{{ eventsInfo.shijian }}&ensp;|&ensp;{{ eventsInfo.address }}</div>
					</div>
					<div class="form_tit">Schedule a meeting using the form below:</div>
					<contact :leixing="eventsInfo.title" titleText="Submit"></contact>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact.vue'  //联系我们
import { eventsList } from '@/api/public_h5';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			eventsInfo: null,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求展会信息
		eventsList({
			custom: that.$route.params.eventsInfoId,
			language: sessionStorage.getItem('lang'),
		}).then(res => {
			document.title = res.data.title + ' - CorDx';
			that.eventsInfo = res.data;
			id: that.isLoading = false;
		});
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块1*/
	.block_1{
		width: 100%;
		padding: 42px 20px;
		background-image: linear-gradient(180deg, #FFFFFF 20%, #F2F7FD 100%);
		.block_1_box{
			width: 100%;
			margin: 0 auto;
			.form_tit{
				padding: 50px 0 25px 0;
				font-size: 18px;
				font-weight: bold;
			}
			.top_box{
				text-align: center;
				.txt{
					padding-top: 20px;
					font-size: 21px;
					color: #0B318F;
				}
				.tit{
					font-size: 42px;
					line-height: 1.3;
				}
			}
		}
	}
}
</style>
